import { Component, Input } from '@angular/core';

@Component({
  selector: 'mk-three-bounce',
  template: `
    <div class="sk-three-bounce">
       <div class="sk-child sk-bounce1" [style.background-color]="colorOne"></div>
       <div class="sk-child sk-bounce2" [style.background-color]="colorTwo"></div>
       <div class="sk-child sk-bounce3" [style.background-color]="colorThree"></div>
     </div>`,
  styles: [`.sk-three-bounce{margin:40px auto;width:80px;text-align:center}.sk-three-bounce .sk-child{width:20px;height:20px;background-color:#333;border-radius:100%;display:inline-block;-webkit-animation:1.4s ease-in-out infinite both sk-three-bounce;animation:1.4s ease-in-out infinite both sk-three-bounce}.sk-three-bounce .sk-bounce1{-webkit-animation-delay:-.32s;animation-delay:-.32s}.sk-three-bounce .sk-bounce2{-webkit-animation-delay:-.16s;animation-delay:-.16s}@-webkit-keyframes sk-three-bounce{0%,100%,80%{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes sk-three-bounce{0%,100%,80%{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}`]
})
export class ThreeBounceComponent {
  @Input() colorOne = '#00a65a';
  @Input() colorTwo = '#fdba2c';
  @Input() colorThree = '#da4733';
}
